import {page_json, progress, progress_form_booking, progress_form_login, progress_form_payment} from './feature.progress.svelte.js';
import {booking} from '../booking/feature.booking.svelte.js';
import * as progress_update from './progress.scenarios.update.svelte.js';
import * as progress_select from './progress.scenarios.select.svelte.js';
import * as debug_actions from "../debug/actions_debug.svelte.js";
import * as remote_actions from "../remote/actions_remote.svelte.js";
import * as booker_actions from "../booker/actions_booker.svelte.js";
import * as products_actions from "../products/actions_products.svelte.js";
import * as packagedeals_actions from "../packagedeals/actions_packagedeals.svelte.js";
import * as actions_progress from "./actions_progress.svelte.js";
import {UI_ID_PANEL40_PACKAGEDEAL, BOOKING_TYPE_PACKAGEDEAL, PRODUCTSET_TYPE_SHOW_FIRST_BOOK_ALL} from "../../AppConstants.js";
import * as progress_actions from "../progress/actions_progress.svelte.js";
import * as booking_select_export from "../booking/booking.scenarios.select.export.svelte.js";
import * as booking_actions from "../booking/actions_booking.svelte.js";
import AppConfig from "../../AppConfig.js";
import * as products_select from '../products/products.scenarios.select.svelte.js';
import {pulseBackground} from "../../utils/ViewUtils.js";
import {products} from "../products/feature.products.svelte.js";
import {packagedeals} from "../packagedeals/feature.packagedeals.svelte.js";
import * as booking_update from "../booking/booking.scenarios.update.svelte.js";

/**
 * Show the availability pending overlay.
 * Used when user performs an action that requires availability data that hasn't loaded yet.
 */
export function showAvailabilityPendingOverlay()
{
  progress.bShowAvailabilityPendingOverlay = true;
}

/**
 * Hide the availability pending overlay and clear any pending user click actions.
 * This ensures that if the user dismisses the overlay, any queued add actions are cancelled.
 */
export function hideAvailabilityPendingOverlay()
{
  progress.bShowAvailabilityPendingOverlay = false;
  booking_actions.clearPendingUserClickActions();
}

export function setDebugMode(bVal)
{
  debug_actions.debugAddLogFlow('progress', 'setDebugMode', {bVal});
  if ( bVal === true || bVal === false )
  {
    progress.bIsDebugModeEnabled = bVal;
  }
}

export function goToStep(iStepNr)
{
  // console.log('goToStep:', iStepNr);
  debug_actions.debugAddLogFlow('progress', 'goToStep', {iStepNr});
  console.log('goToStep', iStepNr);
  progress_update.scenarioTryToGoToStep(iStepNr);
}

export function goToPrevStep()
{
  if ( progress.bIsLoginScreenActive === true )
  {
    progress_actions.closeLoginForm();
    return;
  }

  const iPrevStepNr = progress_select.getPrevStepNr();
  debug_actions.debugAddLogFlow('progress', 'goToPrevStep', {iPrevStepNr});

  if ( iPrevStepNr )
  {
    console.log('goto prev');
    progress_update.scenarioTryToGoToStep(iPrevStepNr);
  }
}

export function updateNextButtonState(sExplicitValue = false)
{
  // let bDebug = true;
  let bDebug = false;

  if ( bDebug === true ) console.log('updateNextButtonState start');

  if ( sExplicitValue !== false )
  {
    if ( bDebug === true ) console.log('updateNextButtonState explicit value ', sExplicitValue);

    progress.sNextButtonState = sExplicitValue;
    return;
  }

  // active, loading, hidden, disabled
  const iNextStepNr = progress_select.getNextStepNr();
  const oIsNewMoveAllowedReport = progress_select.getValidationReport();

  // window.console.log('updateNextButtonState', iNextStepNr, oIsNewMoveAllowedReport);
  if ( progress.bIsFetchingReservationFeedback !== true && (progress.iCurrentVisibleStep === 60 || progress.iCurrentVisibleStep === 70 || progress.iCurrentVisibleStep === 40) )
  {
    // In het formulier en bij de arrangementen kun je altijd de validatie triggeren
    if ( bDebug === true ) console.log('updateNextButtonState active 1');
    progress.sNextButtonState = 'active';
    return;
  }

  const bBlockNextWhileWaitingForAjax = false;

  if ( oIsNewMoveAllowedReport.iHighestStepWithoutValidationErrors >= iNextStepNr )
  {
    // window.console.log('updateNextButtonState 2 - mag een overgang van ', progress.iCurrentVisibleStep, ' naar ', iNextStepNr);
// console.log('B evalueer button state voor ', progress.iCurrentVisibleStep);
    // de move naar next is toegestaan.. maar het is niet in elk scherm altijd wat we willen aanbieden
    switch ( progress.iCurrentVisibleStep )
    {
      case 10:
        // type boeking
        // de eerste keer dat je hier komt auto-progress na klik.. als je terugklikt naar dit scherm dan wel een knop tonen
        if ( progress.iHighestShownStep === 10 && booking.iPreselectedPackageDealID === false )
        {
          if ( bDebug === true ) console.log('updateNextButtonState hidden 10');
          progress.sNextButtonState = 'hidden';
        }
        else
        {
          //console.log("En dit is dus raar want dit is de afhandeling van 10 terwijl iCurrentVisibleStep al 11 was:", $state.snapshot(progress.iHighestShownStep));
          if ( bDebug === true ) console.log('updateNextButtonState active 10');
          progress.sNextButtonState = 'active';
        }
        break;
      case 14:
        // reservering subtype
        // de eerste keer dat je hier komt auto-progress na klik.. als je terugklikt naar dit scherm dan wel een knop tonen
        // Als je binnenkomt met een preselected aantal personen > 1 dan ook meteen de knop tonen
        if ( progress.iHighestShownStep === 14 )
        {
          if ( bDebug === true ) console.log('updateNextButtonState hidden 14');
          progress.sNextButtonState = 'hidden';
        }
        else
        {
          if ( bDebug === true ) console.log('updateNextButtonState active 14');
          progress.bHideNextButton = false;
          progress.sNextButtonState = 'active';
        }
        break;
      case 17:
        // aantal personen
        // de eerste keer dat je hier komt auto-progress na klik.. als je terugklikt naar dit scherm dan wel een knop tonen
        // Als je binnenkomt met een preselected aantal personen > 1 dan ook meteen de knop tonen
        // if ( progress.iHighestShownStep === 17 && booking.iInitialNrOfPeople === 0 )
        // {
        //   if ( bDebug === true ) console.log('updateNextButtonState hidden 17');
        //   progress.sNextButtonState = 'hidden';
        // }
        // else
        // {

        // ik ben het gedoe met deze knop zat.. eens kijken of we niet gewoon zo verder kunnen
        // Ah, de grap is dat we bij het normaal doorlopen van de reserveerstraat blijkbaar hier niet langs komen de eerste keer en de knop toch verborgen is

        if ( bDebug === true ) console.log('updateNextButtonState active 17');
        progress.bHideNextButton = false; // het irritante is dat deze er juist voor zorgt dat als je op het aantal personen klikt je WEL weer de groene knop ziet flitsen
        progress.sNextButtonState = 'active';
        // }
        break;
      case 20:
        if ( bDebug === true ) console.log('updateNextButtonState 20');
        // reminder: je zit hier binnen de if dat het report het al toestaat dat je doorgaat
        progress.bHideNextButton = false;
        progress.sNextButtonState = 'active';
        break;
      case 30:
      case 40:
        if ( bDebug === true ) console.log('updateNextButtonState 30 en 40');

        if ( bBlockNextWhileWaitingForAjax === true )
        {
          if ( progress.bIsFetchingPackageDeals === true || progress.bIsFetchingTreatments === true )
          {
            progress.sNextButtonState = 'loading';
          }
          else
          {
            progress.sNextButtonState = 'active';
          }
        }
        else
        {
          progress.sNextButtonState = 'active';
        }

        break;
      case 50:
        if ( bDebug === true ) console.log('updateNextButtonState 50');

        if ( bBlockNextWhileWaitingForAjax === true )
        {
          if ( progress.bIsFetchingPackageDeals === true )
          {
            progress.sNextButtonState = 'loading';
          }
          else
          {
            progress.sNextButtonState = 'active';
          }
        }
        else
        {
          progress.sNextButtonState = 'active';
        }

        break;
      case 60:
        if ( bDebug === true ) console.log('updateNextButtonState 60');

        if ( bBlockNextWhileWaitingForAjax === true )
        {
          if ( progress.bIsFetchingTreatments === true )
          {
            progress.sNextButtonState = 'loading';

          }
          else
          {
            progress.sNextButtonState = 'active';
          }
        }
        else
        {
          progress.sNextButtonState = 'active';
        }

        break;
      case 70:
        if ( progress.bIsFetchingReservationFeedback === true )
        {
          if ( bDebug === true ) console.log('updateNextButtonState loading 70');
          progress.sNextButtonState = 'loading';
        }
        else
        {
          if ( bDebug === true ) console.log('updateNextButtonState active 70');
          progress.sNextButtonState = 'active';
        }

        break;
      default:
        if ( bDebug === true ) console.log('updateNextButtonState active default', progress.iCurrentVisibleStep);
        progress.sNextButtonState = 'active';
    }

    // hier returnen.. de default van de switch heeft het werk al gedaan
    if ( bDebug === true ) console.log('updateNextButtonState return einde switch');
    return;
  }

  // dit is als je nog niet door mag in de huidige stap
  if ( bDebug === true ) console.log('updateNextButtonState hidden fallback');
  progress.sNextButtonState = 'hidden';
}

export function handleNextButtonClick()
{
  // console.log('handleNextButtonClick - shop', $state.snapshot(progress.iCurrentVisibleStep));
  // dit MOET los staan van goToNextStep omdat we in sommige gevallen de afhandeling terug gaan geven aan een formulier,
  // die vervolgens eerst gaat valideren en ALS het form valide is zelf goToNextStep aanroept
  // Bij de pagina's met formulieren roepen we niet rechtstreeks de goToNextStep aan
  // maar laten we het formulier eea afhandelen door eerst te valideren en dan zelf goToNextStep aan te roepen
  switch ( progress.iCurrentVisibleStep )
  {
    case 10:
      // soms is het handig om in stap 10 een formulier te zetten om te debuggen
      if ( progress.bIsLocal === true )
      {
        if ( AppConfig.bLocalTestFormInStep10Booking && progress_form_booking.form !== false )
        {
          progress_form_booking.form.submit();
        }
        else if ( AppConfig.bLocalTestFormInStep10Login && progress_form_login.form !== false )
        {
          progress_form_login.form.submit();
        }
        else if ( AppConfig.bLocalTestFormInStep10Payment && progress_form_payment.form !== false )
        {
          progress_form_payment.form.submit();
        }
        else
        {
          // console.log('next 1');
          progress_actions.goToNextStep();
        }
      }
      else
      {
        // console.log('next 2');
        progress_actions.goToNextStep();
      }
      break;
    case 40:
      progress_actions.handleStep40NextClick();
      break;
    case 60:
      if ( progress_form_booking.form !== false )
      {
        console.log('submit');
        progress_form_booking.form.submit();
      }
      else
      {
        console.log('geen formulier om te submitten');
      }
      break;
    case 70:
      // console.log('handleNextButtonClick - shop 2');
      if ( progress_form_payment.form !== false )
      {
        // console.log('handleNextButtonClick - shop 3');
        progress_form_payment.form.submit();
      }
      break;

    default:
      // console.log('next default');
      progress_actions.goToNextStep();
  }
}

export function goToNextStep()
{
  // console.log('goToNextStep');
  // soms gaan we meteen, soms handelen we eerst nog wat randzaken af
  const iNextStepNr = progress_select.getNextStepNr();
  debug_actions.debugAddLogFlow('progress', 'goToNextStep', {iNextStepNr});

  // console.log('[DEBUG Nav] goToNextStep() called | currentStep:', progress.iCurrentVisibleStep, '| nextStep:', iNextStepNr);

  // When leaving Step 30 (time selection), fire availability calls
  // At this point we have all required data: date, arrival time, departure time, number of people
  if ( progress.iCurrentVisibleStep === 30 )
  {
    // console.log('[DEBUG Nav] Leaving step 30 | bHasTreatmentsAvailability:', products.bHasTreatmentsAvailability, '| bIsFetchingTreatmentsAvailability:', products.bIsFetchingTreatmentsAvailability);

    // Always fire treatments availability (needed in Step 50)
    if ( !products.bHasTreatmentsAvailability && !products.bIsFetchingTreatmentsAvailability )
    {
      // console.log('[DEBUG Nav] TRIGGERING fetchTreatmentsAvailability from goToNextStep');
      remote_actions.fetchTreatmentsAvailability(
        booking.sArrivalDate,
        booking.iArrivalTime,
        booking.iDepartureTime,
        booking.iNrOfPeople
      );
    }
    else
    {
      // console.log('[DEBUG Nav] NOT triggering fetchTreatmentsAvailability (already has data or fetching)');
    }

    // Fire packagedeals availability only for arrangement flow (needed in Step 40)
    if ( booking.sBookingType === BOOKING_TYPE_PACKAGEDEAL )
    {
      if ( !packagedeals.bHasPackageDealsAvailability && !packagedeals.bIsFetchingPackageDealsAvailability )
      {
        remote_actions.fetchPackageDealsAvailability(
          booking.sArrivalDate,
          booking.iArrivalTime,
          booking.iDepartureTime,
          booking.iNrOfPeople
        );
      }
    }
  }

  // Kijk of de availability call nog steeds aan het laden is en we voorbij stappen proberen te komen waar we die nodig hebben.
  // Toon de overlay als de gebruiker door probeert te gaan terwijl de availability nog niet binnen is
  const bIsLoadingPackageDealsAvailability = packagedeals.bIsFetchingPackageDealsAvailability;
  const bIsLoadingTreatmentsAvailability = products.bIsFetchingTreatmentsAvailability;

  // We gaan uit stap 40 (packagedeals) om naar stap 50 te gaan
  if ( progress.iCurrentVisibleStep === 40 && iNextStepNr === 50 && bIsLoadingPackageDealsAvailability )
  {
    // Show overlay and wait for availability to complete
    progress.bShowAvailabilityPendingOverlay = true;
    waitForPackageDealsAvailabilityThenProceed(iNextStepNr);
    return;
  }

  // We gaan uit stap 50 (behandelingen) om naar stap 60 te gaan
  if ( progress.iCurrentVisibleStep === 50 && iNextStepNr === 60 && bIsLoadingTreatmentsAvailability )
  {
    // Toon overlay en wacht op availability data om door te gaan
    progress.bShowAvailabilityPendingOverlay = true;
    waitForTreatmentsAvailabilityThenProceed(iNextStepNr);
    return;
  }

  // console.log('goToNextStep');
  progress_update.scenarioTryToGoToStep(iNextStepNr);
}

/**
 * Wacht tot packagedeals availability klaar is met laden en ga dan door naar de volgende stap.
 * @param {number} iNextStepNr - De stap waarnaar we proberen te gaan als de availability call klaar is.
 */
function waitForPackageDealsAvailabilityThenProceed(iNextStepNr)
{
  const checkInterval = setInterval(() => {
    // Check of de user de overlay al weg heeft geklikt
    if ( !progress.bShowAvailabilityPendingOverlay )
    {
      clearInterval(checkInterval);
      return;
    }

    // Check of het laden klaar is
    if ( !packagedeals.bIsFetchingPackageDealsAvailability )
    {
      clearInterval(checkInterval);
      progress.bShowAvailabilityPendingOverlay = false;
      progress_update.scenarioTryToGoToStep(iNextStepNr);
    }
  }, 100);

  // Safety timeout na 30 seconds
  setTimeout(() => {
    clearInterval(checkInterval);
    if ( progress.bShowAvailabilityPendingOverlay )
    {
      progress.bShowAvailabilityPendingOverlay = false;
      // Na timeout alsnog doorgaan
      progress_update.scenarioTryToGoToStep(iNextStepNr);
    }
  }, 30000);
}

/**
 * Wait for treatments availability to finish loading, then proceed to next step
 * @param {number} iNextStepNr - The step to navigate to after availability loads
 */
function waitForTreatmentsAvailabilityThenProceed(iNextStepNr)
{
  const checkInterval = setInterval(() => {
    // Check if user dismissed the overlay
    if ( !progress.bShowAvailabilityPendingOverlay )
    {
      clearInterval(checkInterval);
      return;
    }

    // Check if loading is complete
    if ( !products.bIsFetchingTreatmentsAvailability )
    {
      clearInterval(checkInterval);
      progress.bShowAvailabilityPendingOverlay = false;
      progress_update.scenarioTryToGoToStep(iNextStepNr);
    }
  }, 100);

  // Safety timeout after 30 seconds
  setTimeout(() => {
    clearInterval(checkInterval);
    if ( progress.bShowAvailabilityPendingOverlay )
    {
      progress.bShowAvailabilityPendingOverlay = false;
      // Proceed anyway after timeout
      progress_update.scenarioTryToGoToStep(iNextStepNr);
    }
  }, 30000);
}

export function handleStep40NextClick()
{
  // console.log('handleStep40NextClick', $state.snapshot(progress.oValidationReport.aIncorrectFields));

  // alleen blokkeren als er nog keuzes moeten worden gemaakt in een al toegevoegd arrangement
  if ( progress.oValidationReport.aIncorrectFields[UI_ID_PANEL40_PACKAGEDEAL].length > 0 )
  {
    progress_actions.scrollToAndHighlightPackageDealIfOnStep40();
  }

  progress_actions.goToNextStep();
}

export function scrollToAndHighlightPackageDealIfOnStep40()
{
  // Sweetlake: the per-guest choices live in the slide-over, not inline on the page, so there
  // is no #packagedeal_options_ element to scroll to / pulse. Re-open the sidebar for the
  // selected arrangement instead, so the missing choices are surfaced. Step 50 stays blocked
  // by validation until every guest has chosen (progress.scenarios.select aAllowedSteps), so
  // handleStep40NextClick's subsequent goToNextStep() is a no-op and we remain on Step 40.
  if ( progress.bIsEnvSweetLake )
  {
    if ( booking.iCurrentSelectedPackagedealID )
    {
      actions_progress.openPackageDealAddSidebar(booking.iCurrentSelectedPackagedealID);
    }
    return;
  }

  let elContainer = document.getElementById("content-page-inner");
  let elScrollTarget = document.getElementById("packagedeal_options_" + booking.iCurrentSelectedPackagedealID);

  if ( elContainer && elScrollTarget )
  {
    // Methode 1: Gebruik scrollIntoView voor een vloeiende scroll
    // elScrollTarget.scrollIntoView({behavior: 'smooth', block: 'start'});

    // Methode 2: Bereken de offset en scroll direct
    elContainer.scrollTo({top: (elScrollTarget.offsetTop - 30), behavior: 'smooth'});

    pulseBackground("packagedeal_options_" + booking.iCurrentSelectedPackagedealID);
  }

}

export function shortcutToForm()
{
  debug_actions.debugAddLogFlow('progress', 'shortcutToForm');
  const iStepToGoTo = 50;
  progress.iCurrentVisibleStep = iStepToGoTo;
  progress.iHighestShownStep = iStepToGoTo;
}

export function submitOrder()
{
  debug_actions.debugAddLogFlow('progress', 'submitOrder');
  progress_update.scenarioTryToSubmitToServer();
}

export function openReceiptDialog()
{
  progress.bIsReceiptDialogOpen = true;
}

export function closeReceiptDialog()
{
  progress.bIsReceiptDialogOpen = false;
}


export function handleProductTimeSlotPopupClosed()
{
  // eventuele opruimwerkzaamheden
  progress_actions.resetProductTimeSlotPopup();
}

export function resetProductTimeSlotPopup()
{
  // eventuele opruimwerkzaamheden
  progress.oTimeSlotPopup.aAvailableSlots = false;
  progress.oTimeSlotPopup.bIsOpen = false;
  progress.oTimeSlotPopup.iProductID = false;
  progress.oTimeSlotPopup.oPerson = false
}

// De reden dat onderstaande api functies hier staan en niet direct naar actions_remote.svelte.js gaan
// is dat in actions_remote puur de aanroep naar de remote endpoints staan en in deze file hier ook
// de side effects voor elke aanroep worden afgehandeld. Door de aanroep zelf geisoleerd in actions_remote
// te hebben blijft er de mogelijkheid om zo'n aanroep ook los aan te roepen zonder alle gangbare side effects.
export async function apiCallRequestWidgetData(fnCallback)
{
  debug_actions.debugAddLogFlow('progress', 'apiCallRequestWidgetData');
  // progress.sFetchingError = null;
  await remote_actions.fetchWidgetData(fnCallback);
}

export async function apiCallRequestPageData(fnCallback)
{
  debug_actions.debugAddLogFlow('progress', 'apiCallRequestPageData');
  // progress.sFetchingError = null;
  await remote_actions.fetchPageData(fnCallback);
}

export async function apiCallRequestCalendar(fnCallback)
{
  debug_actions.debugAddLogFlow('progress', 'apiCallRequestCalendar');
  progress.bIsFetchingCalendar = true;
  // progress.sFetchingError = null;
  await remote_actions.fetchCalendar(fnCallback);
  progress.bIsFetchingCalendar = false;
}

export async function apiCallRequestCalendarForWidgets(fnCallback)
{
  debug_actions.debugAddLogFlow('progress', 'apiCallRequestCalendarForWidgets');
  progress.bIsFetchingCalendar = true;
  // progress.sFetchingError = null;
  await remote_actions.fetchCalendarForWidgets(fnCallback);
  progress.bIsFetchingCalendar = false;
}

export async function apiCallRequestAvailability(iProductID, sPersonID)
{
  // console.log('debug avail start', iProductID, sPersonID);
  debug_actions.debugAddLogFlow('progress', 'apiCallRequestCalendar');
  // progress.bIsFetchingPackageDeals = true;
  // progress.sFetchingError = null;
  const oBookingExport = booking_select_export.getBookingExport(true);
  const aBookedProductsAndTimes = [];

  oBookingExport.aPeople.forEach((oPersonConfig) => {
    oPersonConfig.allProducts.forEach((oProductForPersonConfig) => {
      let oProduct = products_select.getProductByID(oProductForPersonConfig.iID);

      if ( oProduct && oProduct.bIsTreatment === true )
      {
        if ( iProductID === oProductForPersonConfig.iID && sPersonID === oPersonConfig.sID )
        {
          // het product waar het in de call om gaat moet voor de persoon die we willen plannen zelf UIT de export worden gehaald, maar andere personen die hem hebben moeten er wel in
          return;
        }

        let oBookedProductandTime = {
          iID: oProductForPersonConfig.iID
        };

        // NB we sturen dus alleen behandelingen mee waar een tijdsvoorkeur voor is ingesteld (nogmaals besproken SvS/JB 202509)
        if ( typeof oProductForPersonConfig.sTime !== "undefined" && oProductForPersonConfig.sTime !== 'x' && oProductForPersonConfig.sTime !== 'y' )
        {
          oBookedProductandTime.sTime = oProductForPersonConfig.sTime;
        }

        aBookedProductsAndTimes.push(oBookedProductandTime);
      }
    });
  });

  progress.oTimeSlotPopup.aAvailableSlots = false;
// console.log('debug avail', aBookedProductsAndTimes);
  let oResponse = await remote_actions.fetchProductAvailability(iProductID, booking.sArrivalDate, booking.sArrivalDate, booking.iArrivalTime, booking.iDepartureTime, JSON.stringify(aBookedProductsAndTimes));

  if ( parseInt(oResponse.iID) === progress.oTimeSlotPopup.iProductID )
  {
    progress.oTimeSlotPopup.sDebug = oResponse.sDebug;
    progress.oTimeSlotPopup.sTitle = oResponse.sTitle;
    progress.oTimeSlotPopup.aAvailableSlots = oResponse.aTimeSlots; // keys L en V

    if ( progress.oTimeSlotPopup.aAvailableSlots.length === 0 && (AppConfig.bDebugUseFakeAjaxCalls === true || window.hmk_bForceAvailableTreatments === true) )
    {
      progress.oTimeSlotPopup.aAvailableSlots = [
        {V: "1100", L: "Om 11:00"},
        {V: "1200", L: "Om 12:00"},
        {V: "1300", L: "Om 13:00"},
        {V: "1400", L: "Om 14:00"}
      ];
    }
  }
  else
  {
    window.console.log("Negereer productdata omdat het voor een vorig product is.")
  }
}

/**
 * Productset variant — fetches available time slots for one (product, person) pair
 * and returns them. Unlike apiCallRequestAvailability above, this does NOT mutate
 * the singleton progress.oTimeSlotPopup. Multiple inline pickers (one per added
 * variant card inside the productset modal) can run their fetches in parallel
 * without clobbering each other.
 *
 * Same booking-context payload as the singleton flow so the backend's slot
 * availability accounts for currently-booked treatments. Same fake-data dev
 * fallback (AppConfig.bDebugUseFakeAjaxCalls / window.hmk_bForceAvailableTreatments).
 *
 * Returns: array of { V: string, L: string } slot configs. Empty array means
 * no slots available for this product/date.
 */
export async function apiCallRequestProductTimeSlots(iProductID, sPersonID)
{
  // Single-person variant: exclude just this one (product, person) from the availability
  // context. Delegates to the set-aware variant with a one-element member list.
  return apiCallRequestProductTimeSlotsForSet(iProductID, sPersonID ? [sPersonID] : []);
}

/**
 * Set-aware timeslot fetch (D15). Excludes ALL given member person IDs (who hold this product)
 * from the availability context, so a booked-together set never self-counts its own members
 * against its own slot availability — this is the bug the per-person variant would hit for a set,
 * especially when editing an existing set. Other people's bookings stay in the context, so the
 * result is cart-aware. Pass aMemberPersonIDs = [] when the set isn't in the cart yet (nothing of
 * ours to exclude).
 */
export async function apiCallRequestProductTimeSlotsForSet(iProductID, aMemberPersonIDs = [])
{
  debug_actions.debugAddLogFlow('progress', 'apiCallRequestProductTimeSlotsForSet', {iProductID, aMemberPersonIDs});

  const aMembers = Array.isArray(aMemberPersonIDs) ? aMemberPersonIDs : [];
  const oBookingExport = booking_select_export.getBookingExport(true);
  const aBookedProductsAndTimes = [];

  oBookingExport.aPeople.forEach((oPersonConfig) => {
    oPersonConfig.allProducts.forEach((oProductForPersonConfig) => {
      let oProduct = products_select.getProductByID(oProductForPersonConfig.iID);

      if ( oProduct && oProduct.bIsTreatment === true )
      {
        // The product being planned must be taken OUT of the export for every member of the set
        // we're planning — other people who have the same product stay in (matches
        // apiCallRequestAvailability). For a single-person fetch aMembers holds just one id.
        if ( iProductID === oProductForPersonConfig.iID && aMembers.includes(oPersonConfig.sID) )
        {
          return;
        }

        let oBookedProductandTime = {
          iID: oProductForPersonConfig.iID
        };

        if ( typeof oProductForPersonConfig.sTime !== "undefined" && oProductForPersonConfig.sTime !== 'x' && oProductForPersonConfig.sTime !== 'y' )
        {
          oBookedProductandTime.sTime = oProductForPersonConfig.sTime;
        }

        aBookedProductsAndTimes.push(oBookedProductandTime);
      }
    });
  });

  let oResponse = await remote_actions.fetchProductAvailability(
    iProductID,
    booking.sArrivalDate,
    booking.sArrivalDate,
    booking.iArrivalTime,
    booking.iDepartureTime,
    JSON.stringify(aBookedProductsAndTimes)
  );

  let aSlots = (oResponse && oResponse.aTimeSlots) || [];

  if ( aSlots.length === 0 && (AppConfig.bDebugUseFakeAjaxCalls === true || (typeof window !== 'undefined' && window.hmk_bForceAvailableTreatments === true)) )
  {
    aSlots = [
      {V: "1100", L: "Om 11:00", P: 1},
      {V: "1200", L: "Om 12:00", P: 2},
      {V: "1300", L: "Om 13:00", P: 5},
      {V: "1400", L: "Om 14:00", P: 3}
    ];
  }

  return aSlots;
}

export async function apiCallRequestRestaurantAvailability(sPersonID)
{
  // console.log('debug avail rest start', sPersonID);
  debug_actions.debugAddLogFlow('progress', 'apiCallRequestRestaurantAvailability');

  progress.bIsFetchingRestaurant = true;

  const oBookingExport = booking_select_export.getBookingExport(true);
  const aBookedProductsAndTimes = [];

  oBookingExport.aPeople.forEach((oPersonConfig) => {
    oPersonConfig.allProducts.forEach((oProductForPersonConfig) => {
      let oProduct = products_select.getProductByID(oProductForPersonConfig.iID);

      if ( oProduct && oProduct.bIsTreatment === true )
      {
        if ( AppConfig.iDinnerProductID === oProductForPersonConfig.iID )
        {
          // het dinner product waar het in de call om gaat moet UIT de export worden gehaald
          return;
        }

        let oBookedProductandTime = {
          iID: oProductForPersonConfig.iID
        };

        // NB we sturen dus alleen behandelingen mee waar een tijdsvoorkeur voor is ingesteld (nogmaals besproken SvS/JB 202509)
        if ( typeof oProductForPersonConfig.sTime !== "undefined" && oProductForPersonConfig.sTime !== 'x' && oProductForPersonConfig.sTime !== 'y' )
        {
          oBookedProductandTime.sTime = oProductForPersonConfig.sTime;
        }

        aBookedProductsAndTimes.push(oBookedProductandTime);
      }
    });
  });

  // console.log('debug avail rest', aBookedProductsAndTimes);

  let oResponse = await remote_actions.fetchRestaurantProductAvailability(booking.sArrivalDate, booking.sArrivalDate, booking.iArrivalTime, booking.iDepartureTime, JSON.stringify(aBookedProductsAndTimes));

  //oResponse.sDebug;
  ///oResponse.sTitle;

  // We hebben de tijdslots teruggekregen, maar we moeten nog kijken welke tijdslots nog plek hebben voor het aantal personen in deze boeking
  if ( oResponse.aTimeSlots === false || oResponse.aTimeSlots === null )
  {
    products.aAvailableRestaurantTimes = [];
  }
  else
  {
    let aFilteredTimeSlotConfigs = [];
    let iNrOfPeople = booking.lPeople.length;

    oResponse.aTimeSlots.forEach((oTimeSlotConfig) => {
      // keys L en V en P voor het aantal plekken dat beschikbaar is in dat slot
      let iNrOfPlacesInSlot = parseInt(oTimeSlotConfig.P);

      if ( iNrOfPlacesInSlot >= iNrOfPeople )
      {
        aFilteredTimeSlotConfigs.push(oTimeSlotConfig);
      }
    });

    products.aAvailableRestaurantTimes = aFilteredTimeSlotConfigs;
  }

  if ( progress.oTimeSlotPopup.aAvailableSlots.length === 0 && AppConfig.bDebugUseFakeAjaxCalls === true )
  {
    progress.oTimeSlotPopup.aAvailableSlots = [
      {V: "1100", L: "Om 11:00"},
      {V: "1200", L: "Om 12:00"},
      {V: "1300", L: "Om 13:00"},
      {V: "1400", L: "Om 14:00"}
    ];
  }

  progress.bIsFetchingRestaurant = false;
}

export async function apiCallRequestPackageDealsDummy()
{
  debug_actions.debugAddLogFlow('progress', 'apiCallRequestPackageDealsDummy');
  progress.bIsFetchingPackageDeals = true;
  progress_actions.updateNextButtonState();

  progress.sFetchingError = null;
  // er zijn geen meerdaagse arrangementen
  const oRemoteResponse = await remote_actions.fetchPackageDeals(booking.sArrivalDate, booking.sArrivalDate, booking.iArrivalTime, booking.iDepartureTime, true)
  packagedeals_actions.importFromOfAjaxCall(oRemoteResponse);
  //window.console.log('apiCallRequestPackageDeals', oRemoteResponse);
  // booking_update_receipt.calculateBookingTotals();
  booking_actions.handleBookingUpdated('apiCallRequestPackageDealsDummy');
}

export async function apiCallRequestPackageDeals(fnCallback)
{
  debug_actions.debugAddLogFlow('progress', 'apiCallRequestPackageDeals');
  progress.bIsFetchingPackageDeals = true;
  progress_actions.updateNextButtonState();

  progress.sFetchingError = null;
  // er zijn geen meerdaagse arrangementen
  const oRemoteResponse = await remote_actions.fetchPackageDeals(booking.sArrivalDate, booking.sArrivalDate, booking.iArrivalTime, booking.iDepartureTime)
  packagedeals_actions.importFromOfAjaxCall(oRemoteResponse);
  //window.console.log('apiCallRequestPackageDeals', oRemoteResponse);
  progress.bIsFetchingPackageDeals = false;
  // booking_update_receipt.calculateBookingTotals();
  booking_actions.handleBookingUpdated('apiCallRequestPackageDeals');

  if ( typeof fnCallback === "function" )
  {
    fnCallback();
  }
}

export async function apiCallPackageDealsFailure(error)
{
  debug_actions.debugAddLogFlow('progress', 'apiCallPackageDealsFailure', {error});
  progress.bIsFetchingPackageDeals = false;
  progress.htmlPackageDeals = null;
  progress.sFetchingError = error;
  progress_actions.updateNextButtonState();
}

export async function apiCallRequestTreatmentsDummy()
{
  //window.console.log('naar apiCallRequestTreatments 1');
  debug_actions.debugAddLogFlow('progress', 'apiCallRequestTreatmentsDummy');
  progress.bIsFetchingTreatments = true;
  progress_actions.updateNextButtonState();

  progress.sFetchingError = null;
  const oRemoteResponse = await remote_actions.fetchTreatments(booking.sArrivalDate, booking.sArrivalDate, booking.iArrivalTime, booking.iDepartureTime, true);
  products_actions.importFromOfAjaxCall(oRemoteResponse);
  //window.console.log('apiCallRequestPackageDeals', oRemoteResponse);
  // booking_update_receipt.calculateBookingTotals();
  booking_actions.handleBookingUpdated('apiCallRequestTreatmentsDummy');
}

export async function apiCallRequestTreatments(fnCallback)
{
  //window.console.log('naar apiCallRequestTreatments 1');
  debug_actions.debugAddLogFlow('progress', 'apiCallRequestTreatments');
  progress.bIsFetchingTreatments = true;
  progress_actions.updateNextButtonState();

  progress.sFetchingError = null;
  const oRemoteResponse = await remote_actions.fetchTreatments(booking.sArrivalDate, booking.sArrivalDate, booking.iArrivalTime, booking.iDepartureTime);
  products_actions.importFromOfAjaxCall(oRemoteResponse);

  // bij binnenkomen nieuwe behandeldata voor de dag dan alle tijden bij behandelingen clearen
  // en alle niet choiceid 0 behandelingen weg die bIsAvailable !== true
  booking_update.removeAllTimeSlotChoices();
  booking_update.removeUnavailableTreatments();

  //window.console.log('apiCallRequestPackageDeals', oRemoteResponse);
  progress.bIsFetchingTreatments = false;
  // booking_update_receipt.calculateBookingTotals();
  booking_actions.handleBookingUpdated('apiCallRequestTreatments');

  if ( typeof fnCallback === "function" )
  {
    fnCallback();
  }
}

export async function apiCallTreatmentsFailure(error)
{
  debug_actions.debugAddLogFlow('progress', 'apiCallTreatmentsFailure', {error});
  progress.bIsFetchingTreatments = false;
  progress.htmlTreatments = null;
  progress.sFetchingError = error;
  progress_actions.updateNextButtonState();
}

export async function apiCallRequestCustomerID(sEmail, sPassword, fnCallback)
{
  // console.log('apiCallRequestCustomerID', sEmail, sPassword);
  debug_actions.debugAddLogFlow('progress', 'customerIdRemoteGetRequest', {sEmail, sPassword});
  progress.bIsFetchingLogin = true;
  progress_actions.updateNextButtonState();
// console.log('oRemoteResponse 0:');
  const oRemoteResponse = await remote_actions.fetchCustomerID(sEmail, sPassword);
// console.log('oRemoteResponse 1:', oRemoteResponse);
  if ( oRemoteResponse )
  {
    console.log('oRemoteResponse 2:', oRemoteResponse);
    if ( oRemoteResponse.bIsValid === true )
    {

      debug_actions.debugAddLogFlow('progress', 'customerIdRemoteGetSuccess');
      progress.sFetchingLoginError = false;
      progress.bIsFetchingLogin = false;
      progress_actions.updateNextButtonState();
      booker_actions.handleCustomerIDSuccess(oRemoteResponse);
      progress.iLoginScreenComponentRefreshCounter += 1;

      if ( typeof fnCallback === "function" )
      {
        fnCallback();
      }
    }
    else
    {
      debug_actions.debugAddLogFlow('progress', 'customerIdRemoteGetInvalid');
      progress.sFetchingLoginError = 'Deze inloggegevens kloppen niet, probeer het opnieuw';
      progress.bIsFetchingLogin = false;
      progress_actions.updateNextButtonState();
    }
  }
  else
  {
    debug_actions.debugAddLogFlow('progress', 'customerIdRemoteGetFailure');
    progress.bIsFetchingLogin = false;
    progress_actions.updateNextButtonState();
    booker_actions.handleCustomerIDInvalid();
  }
}


export function openLoginForm()
{
  debug_actions.debugAddLogFlow('progress', 'openLoginForm');
  progress.bIsLoginScreenActive = true;
}

export function closeLoginForm()
{
  debug_actions.debugAddLogFlow('progress', 'closeLoginForm');
  progress.bIsLoginScreenActive = false;
}

export function importFromPageConfigAjaxCall()
{
  if ( typeof page_json.data.bShowGate !== 'undefined' ) progress.bShowGate = !!page_json.data.bShowGate;
  if ( typeof page_json.data.jsonHmkCustomerUrl !== 'undefined' && page_json.data.jsonHmkCustomerUrl !== 'false' && page_json.data.jsonHmkCustomerUrl !== false ) progress.sFetchCustomerAPIEndpoint = page_json.data.jsonHmkCustomerUrl;
  if ( typeof page_json.data.jsonHmkPasswordUrl !== 'undefined' && page_json.data.jsonHmkPasswordUrl !== 'false' && page_json.data.jsonHmkPasswordUrl !== false ) progress.sURLPassword = page_json.data.jsonHmkPasswordUrl;
  if ( typeof page_json.data.jsonHmkPrivacyUrl !== 'undefined' && page_json.data.jsonHmkPrivacyUrl !== 'false' && page_json.data.jsonHmkPrivacyUrl !== false ) progress.sURLPrivacy = page_json.data.jsonHmkPrivacyUrl;
  if ( typeof page_json.data.jsonHmkHouseholdRulesUrl !== 'undefined' && page_json.data.jsonHmkHouseholdRulesUrl !== 'false' && page_json.data.jsonHmkHouseholdRulesUrl !== false ) progress.sURLHouseholdRules = page_json.data.jsonHmkHouseholdRulesUrl;
  if ( typeof page_json.data.jsonHmkInsuranceUrl !== 'undefined' && page_json.data.jsonHmkInsuranceUrl !== 'false' && page_json.data.jsonHmkInsuranceUrl !== false ) progress.sURLInsurance = page_json.data.jsonHmkInsuranceUrl;

}

export function openGenericDialog(sTitle, sContent)
{
  progress.sDialogTitle = sTitle;
  progress.sDialogContent = '<div>' + sContent + '</div>';
  progress.bIsDialogOpen = true;
}

export function closeGenericDialog()
{
  progress.bIsDialogOpen = true;
  progress.sDialogTitle = '';
  progress.sDialogContent = '';
}

export function openPackageDealDialog(iPackageDealID)
{
  progress.iPackageDialogPackageDealID = iPackageDealID;
  progress.bIsPackageDealDialogOpen = true;
}

export function closePackageDealDialog()
{
  progress.bIsPackageDealDialogOpen = true;
  progress.iPackageDialogPackageDealID = 0;
}

export function openProductDialog(iProductID, iProductSetID = 0)
{
  console.log('openProductDialog', iProductID, iProductSetID);
  progress.iProductDialogProductID = iProductID;
  progress.iProductDialogProductSetID = parseInt(iProductSetID, 10) || 0;
  progress.bIsProductDialogOpen = true;
}

export function closeProductDialog()
{
  progress.bIsProductDialogOpen = true;
  progress.iProductDialogProductID = 0;
  progress.iProductDialogProductSetID = 0;
}

export function openProductsetAddSidebar(aProductIDs, sDurationLabel, iProductSetID = 0)
{
  console.log('openProductsetAddSidebar', aProductIDs, sDurationLabel, iProductSetID);
  progress.iProductsetAddSidebarProductSetID = parseInt(iProductSetID, 10) || 0;
  progress.aProductsetAddSidebarProductIDs = aProductIDs;
  progress.sProductsetAddSidebarDurationLabel = sDurationLabel;
  progress.bIsProductsetAddSidebarOpen = true;
}

export function closeProductsetAddSidebar()
{
  progress.bIsProductsetAddSidebarOpen = false;
  progress.iProductsetAddSidebarProductSetID = 0;
  progress.aProductsetAddSidebarProductIDs = [];
  progress.sProductsetAddSidebarDurationLabel = '';
}

export function openProductsetTogetherSidebar(aProductIDs, sDurationLabel, iProductSetID = 0)
{
  progress.iProductsetTogetherSidebarProductSetID = parseInt(iProductSetID, 10) || 0;
  progress.aProductsetTogetherSidebarProductIDs = aProductIDs;
  progress.sProductsetTogetherSidebarDurationLabel = sDurationLabel;
  progress.bIsProductsetTogetherSidebarOpen = true;
}

export function closeProductsetTogetherSidebar()
{
  progress.bIsProductsetTogetherSidebarOpen = false;
  progress.iProductsetTogetherSidebarProductSetID = 0;
  progress.aProductsetTogetherSidebarProductIDs = [];
  progress.sProductsetTogetherSidebarDurationLabel = '';
}

export function openProductAddFlow(iAnchorProductID, iProductSetID = 0)
{
  // Canonical "Toevoegen" action for a Sweetlake product card. Persisted sets resolve
  // explicitly by local ProductSet ID; ungrouped products and the temporary legacy
  // fallback resolve from the anchor. Shared by the card and info-dialog actions.
  const oSet = products_select.getProductsetForAnchorID(iAnchorProductID, iProductSetID);

  if ( oSet.sType === PRODUCTSET_TYPE_SHOW_FIRST_BOOK_ALL )
  {
    const aHiddenProductIDs = oSet.aProductIDs.filter(
      (iProductID) => parseInt(iProductID, 10) !== parseInt(oSet.iMainProductID, 10)
    );
    const bHasUnsupportedHiddenMember = aHiddenProductIDs.some(
      (iProductID) => products_select.isTimeSelectionRequiredForProduct(iProductID)
        || products_select.getRequiredPeopleForProduct(iProductID) > 1
    );

    if ( bHasUnsupportedHiddenMember )
    {
      console.error('ProductSet kan niet worden geopend: een verborgen product vereist een eigen tijd- of persoonskeuze.', oSet);
      return;
    }

    actions_progress.openProductsetAddSidebar(
      [oSet.iMainProductID],
      oSet.sDurationLabel,
      oSet.iProductSetID
    );
    return;
  }

  // Multi-person treatments (couples) use a dedicated flow (people picker + shared time)
  // instead of the per-guest productset sidebar.
  const bIsMultiPerson = oSet.aProductIDs.some((iID) => products_select.getRequiredPeopleForProduct(iID) > 1);
  if ( bIsMultiPerson )
  {
    actions_progress.openProductsetTogetherSidebar(oSet.aProductIDs, oSet.sDurationLabel, oSet.iProductSetID);
    return;
  }

  actions_progress.openProductsetAddSidebar(oSet.aProductIDs, oSet.sDurationLabel, oSet.iProductSetID);
}

export function openPackageDealAddSidebar(iPackageDealID)
{
  progress.iPackageDealAddSidebarID = parseInt(iPackageDealID);
  progress.bIsPackageDealAddSidebarOpen = true;
}

export function closePackageDealAddSidebar()
{
  progress.bIsPackageDealAddSidebarOpen = false;
  progress.iPackageDealAddSidebarID = 0;
}

export function openPackageDealAddFlow(iPackageDealID)
{
  // Canonieke "Toevoegen/Bewerken" actie voor een Sweetlake arrangement-card. Mirror van
  // openProductAddFlow: selecteert het arrangement (addOrReplace, mét availability-check)
  // én opent de per-gast keuze-sidebar. Het arrangement-model is single-select, dus
  // alleen (her)selecteren als dit nog niet het actieve arrangement is — bij "Bewerken"
  // van het al-geselecteerde arrangement openen we enkel de sidebar.
  iPackageDealID = parseInt(iPackageDealID);

  if ( booking.iCurrentSelectedPackagedealID !== iPackageDealID )
  {
    booking_actions.addOrReplacePackageDealWithAvailabilityCheck(iPackageDealID);
  }

  actions_progress.openPackageDealAddSidebar(iPackageDealID);
}

export function openPackageDealDeleteConfirm(iPackageDealID)
{
  // Bevestig-overlay vóór het verwijderen van een arrangement uit de bon. Een arrangement
  // geldt voor álle gasten, dus bij >1 bezoeker waarschuwen we eerst (de aanroeper bepaalt
  // die conditie; hier alleen openen + het ID onthouden).
  progress.iPackageDealDeleteConfirmID = parseInt(iPackageDealID);
  progress.bShowPackageDealDeleteConfirmOverlay = true;
}

export function closePackageDealDeleteConfirm()
{
  progress.bShowPackageDealDeleteConfirmOverlay = false;
  progress.iPackageDealDeleteConfirmID = 0;
}

export function confirmPackageDealDelete()
{
  // "Verwijderen": voer de daadwerkelijke verwijdering uit en sluit de overlay.
  const iPackageDealID = progress.iPackageDealDeleteConfirmID;
  if ( iPackageDealID )
  {
    booking_actions.removePackageDeal(iPackageDealID);
  }
  // Kwam de verwijdering vanuit de arrangement-sidebar? Schuif die dan ook dicht. Alleen de
  // open-vlag omzetten (niet closePackageDealAddSidebar) zodat de sidebar via zijn eigen onClose
  // het ID ná de sluit-animatie opruimt — geen lege-body flits. No-op als de sidebar al dicht was.
  progress.bIsPackageDealAddSidebarOpen = false;
  actions_progress.closePackageDealDeleteConfirm();
}

export function closeAllDialogs()
{
  actions_progress.closeGenericDialog();
  actions_progress.closeProductDialog();
  actions_progress.closeProductsetAddSidebar();
  actions_progress.closePackageDealAddSidebar();
  actions_progress.closePackageDealDeleteConfirm();
  actions_progress.closePackageDealDialog();
}
